module.exports = __webpack_public_path__ + "img/clicktrade.39a0172c.png";